import { Button, Menu, MenuContent, MenuList, MenuItem } from '@patternfly/react-core'
import React, { ReactNode } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { excludeDeprecatedModels, excludeNonLicensedModels, excludeUserHiddenModels, includeDeprecatedModels, includeNonLicensedModels, includeUserHiddenModels } from '../../store/reducers';
import { getDeprecatedModels, getIncludeDeprecatedModels, getIncludeNonLicensedModels, getIncludeUserHiddenModels, getNonLicensedModels, getUserHiddenModels } from '../../store/selectors';
import { CaretDownIcon, CaretUpIcon } from '@patternfly/react-icons'
import { useTranslation } from 'react-i18next';


const CustomizationFilters = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const nonLicensedModels = useSelector(getNonLicensedModels);
    const deprecatedModels = useSelector(getDeprecatedModels);
    const hiddenModels = useSelector(getUserHiddenModels);

    const areDeprecatedModelsShown = useSelector(getIncludeDeprecatedModels);
    const areNonLicensedModelsShown = useSelector(getIncludeNonLicensedModels);
    const areUserHiddenModelsShown = useSelector(getIncludeUserHiddenModels);

    const [isModelFiltersSelectOpen, toggleModelFiltersSelect] = React.useState(false);

    const handleAllModelsVisibilityIcon = (): ReactNode => {
        return (isModelFiltersSelectOpen) ? <CaretUpIcon className='models-visibility-icon' /> : <CaretDownIcon className='models-visibility-icon' />;
    }


    const handleModelsVisibilityChange = (type: 'deprecated' | 'non-licensed' | 'user-hidden') => {
        switch (type) {
            case "non-licensed":
                if (areNonLicensedModelsShown === false) {
                    dispatch(includeNonLicensedModels());
                } else {
                    dispatch(excludeNonLicensedModels());
                }
                break;
            case "deprecated":
                if (areDeprecatedModelsShown === false) {
                    dispatch(includeDeprecatedModels());
                } else {
                    dispatch(excludeDeprecatedModels());
                }
                break;
            case "user-hidden":
                if (areUserHiddenModelsShown === false) {
                    dispatch(includeUserHiddenModels());
                } else {
                    dispatch(excludeUserHiddenModels());
                }
                break;
            default:
                throw new Error('Unsupported visibility change type');
        }
    };

    return (
        <>
            <Button variant="secondary" className='deprecated-models-toggle' onClick={() => toggleModelFiltersSelect(!isModelFiltersSelectOpen)}> {t('filterModels.title')}{handleAllModelsVisibilityIcon()}
            </Button >
            {isModelFiltersSelectOpen &&
                <Menu className="customization-filter-menu">
                    <MenuContent>
                        <MenuList>
                            <MenuItem className='models-filter-menu-item' itemId={1} onClick={() => handleModelsVisibilityChange('deprecated')} hasCheck isSelected={areDeprecatedModelsShown} title={t('filterModels.showDeprecated')}>{t('filterModels.showDeprecated')}{deprecatedModels.length > 0 && ` (${deprecatedModels.length})`}</MenuItem>
                            <MenuItem className='models-filter-menu-item' itemId={2} onClick={() => handleModelsVisibilityChange('non-licensed')} hasCheck isSelected={areNonLicensedModelsShown} title={t('filterModels.showUnavailable')}>{t('filterModels.showUnavailable')}{nonLicensedModels.length > 0 && ` (${nonLicensedModels.length})`}</MenuItem>
                            <MenuItem className='models-filter-menu-item' itemId={3} onClick={() => handleModelsVisibilityChange('user-hidden')} hasCheck isSelected={areUserHiddenModelsShown} title={t('filterModels.showHidden')}>{t('filterModels.showHidden')}{hiddenModels.length > 0 && ` (${hiddenModels.length})`}</MenuItem>
                        </MenuList>
                    </MenuContent>
                </Menu>
            }
        </>
    )
}

export default CustomizationFilters